/*
 * BioIndex
 * Copyright (c) 2026 BioIndex™. All rights reserved.
 * Unauthorized copying, scraping, redistribution, or commercial reuse is prohibited.
 */

import useScrollMemory from "../hooks/useScrollMemory";
import BioIndexExploreLevelLayout, {
  BioIndexTaxonCard,
} from "../components/BioIndexExploreLevelLayout";
import { useParams, useLocation } from "react-router-dom";
import { iconUrl, defaultImg } from "../utils/icons";
import { ordersByClass } from "../utils/taxonomy";
import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db, auth } from "../firebase";
import { familiesByOrder } from "../utils/taxonomy";
import { generaByFamily } from "../utils/taxonomy";

export const orderImages = {
  Characiformes: "Pygocentrus.png",
  Osteoglossiformes: "Scleropages.png",
  Labriformes: "Thalassoma.png",
  Blenniiformes: "Amphiprion.png",
  Acanthuriformes: "Chelmon.png",
  Lamniformes: "Carcharias.png",
  Syngnathiformes: "Syngnathus.png",
  Myliobatiformes: "Hypanus.png",
  Cupressales: "Cupressus.png",
  Microbiotheriidae: "Dromiciops.png",
  Gaviiformes: "Gavia.png",
  Fucales: "Sargassum.png",
  Tetraodontiformes: "Lactophrys.png",
  Escalloniales: "Escallonia.png",
  Canellales: "Drimys.png",
  Oxalidales: "Caldcluvia.png",
  Centrarchiformes: "Micropterus.png",
  Cucurbitales: "Begonia.png",
  Camarodonta: "Paracentrotus.png",
  Clypeasteroida: "Mellita.png",
  Dermochelyidae: "Dermochelys.png",
  Auriculariales: "Auricularia.png",
  Chloranthales: "Hedyosmum.png",
  Agaricales: "Amanita.png",
  Boletales: "Suillus.png",
  Hypocreales: "Hypomyces.png",
  Dipsacales: "Vesalea.png",
  Santalales: "Helosis.png",
  Zygentoma: "Ctenolepisma.png",
  Geraniales: "Geranium.png",
  Lepidoziales: "Herbertus.png",
  Polypodiales: "Polystichum.png",
  Grimmiales: "Racomitrium.png",
  Sphenisciformes: "Spheniscus.png",
  Cornales: "Cornus.png",
  Buxales: "Buxus.png",
  Ulmaceae: "Ulmus.png",
  Ciconiiformes: "Ciconia.png",
  Accipitriformes: "Spizaetus.png",
  Acari: "Bryobia.png",
  Anseriformes: "Anas.png",
  Apodiformes: "Aglaiocercus.png",
  Caprimulgiformes: "Chordeiles.png",
  Cathartiformes: "Cathartes.png",
  Causuariiformes: "Dromaius.png",
  Charadriiformes: "Larus.png",
  Columbiformes: "Patagioenas.png",
  Coraciiformes: "Momotus.png",
  Cuculiformes: "Crotophaga.png",
  Eurypygiformes: "Eurypyga.png",
  Rodentia: "Dasyprocta.png",
  Piciformes: "Ramphastos.png",
  Squamata: "Iguana.png",
  Falconiformes: "Falco.png",
  Galliformes: "Ortalis.png",
  Gruiformes: "Grus.png",
  Nyctibiiformes: "Nyctibius.png",
  Opisthocomiformes: "Opisthocomus.png",
  Passeriformes: "Passer.png",
  Pelecaniformes: "Pelecanus.png",
  Phaethontiformes: "Phaethon.png",
  Phoenicopteriformes: "Phoenicopterus.png",
  Podicipediformes: "Podilymbus.png",
  Procellariiformes: "Phoebastria.png",
  Psittaciformes: "Amazona.png",
  Steatornithes: "Steatornis.png",
  Strigiformes: "Asio.png",
  Suliformes: "Sula.png",
  Trogoniformes: "Trogon.png",
  Cypriniformes: "Cyprinus.png",
  Perciformes: "Prionurus.png",
  Anguilliformes: "Uropterygius.png",
  Anura: "Agalychnis.png",
  Primates: "Saguinus.png",
  Artiodactyla: "Bos.png",
  Carnivora: "Ursus.png",
  Cetacea: "Tursiops.png",
  Chiroptera: "Artibeus.png",
  Orectolobiformes: "Rhincodon.png",
  Cingulata: "Dasypus.png",
  Struthioniformes: "Tinamus.png",
  Didelphimorphia: "Didelphis.png",
  Odonata: "Brachymesia.png",
  Lagomorpha: "Sylvilagus.png",
  Perissodactyla: "Equus.png",
  Pilosa: "Bradypus.png",
  Pinnipedia: "Zalophus.png",
  Crocodylia: "Crocodylus.png",
  Testudines: "Chelonoidis.png",
  Araneae: "Sphaerobothria.png",
  Scorpiones: "Centruroides.png",
  Scolopendromorpha: "Scolopendra.png",
  Scutigeromorpha: "Scutigera.png",
  Blattodea: "Archimandrita.png",
  Coleoptera: "Pseudoxychelia.png",
  Hemiptera: "Chinavia.png",
  Hymenoptera: "Polistes.png",
  Lepidoptera: "Diaethria.png",
  Mantodea: "Choeradodis.png",
  Orthoptera: "Brachystola.png",
  Decapoda: "Ocypode.png",
  Anisoptera: "Brachymesia.png",
  Chitonida: "Chiton.png",
  Semaeostomeae: "Chrysaora.png",
  Diadematoida: "Diadema.png",
  Forcipulatida: "Pisaster.png",
  Ginkgoales: "Ginkgo.png",
  Phallales: "Phallus.png",
  Selaginellales: "Selaginella.png",
  Apiales: "Foeniculum.png",
  Asterales: "Tithonia.png",
  Aquifoliales: "Ilex.png",
  Boraginales: "Cordia.png",
  Brassicales: "Carica.png",
  Caryophyllales: "Nepenthes.png",
  Celastrales: "Parnassia.png",
  Ericales: "Gaultheria.png",
  Fabales: "Leucaena.png",
  Fagales: "Fagus.png",
  Gentianales: "Asclepias.png",
  Lamiales: "Lavandula.png",
  Laurales: "Ocotea.png",
  Magnoliales: "Magnolia.png",
  Malpighiales: "Bunchosia.png",
  Malvales: "Malvaviscus.png",
  Piperales: "Piper.png",
  Proteales: "Platanus.png",
  Ranunculales: "Bocconia.png",
  Rosales: "Fragaria.png",
  Sapindales: "Acer.png",
  Saxifragales: "Liquidambar.png",
  Solanales: "Solanum.png",
  Vitales: "Parthenocissus.png",
  Myrtales: "Psidium.png",
  Alismatales: "Anthurium.png",
  Arecales: "Bismarckia.png",
  Asparagales: "Sansevieria.png",
  Commelinales: "Tradescantia.png",
  Dioscoreales: "Dioscorea.png",
  Poales: "Saccharum.png",
  Zingiberales: "Zingiber.png",
  Jungermanniales: "Jungermannia.png",
  Pinales: "Pinus.png",
  Cycadales: "Cycas.png",
  Equisetales: "Equisetum.png",
  Pteridales: "Nephrolepis.png",
  Arthoniales: "Cryptothecia.png",
  Lecanorales: "Cladonia.png",
  Pucciniales: "Hemileia.png",
  Polyporales: "Trametes.png",
  Russulales: "Lactarius.png",
  Tinamiformes: "Tinamus.png",
  Stylommatophora: "Arion.png",
  Gymnophiona: "Gymnopis.png",
  Caudata: "Bolitoglossa.png",
  Siluriformes: "Pimelodus.png",
};

function getOrderImage(orderName) {
  const filename = orderImages[orderName];
  return filename ? iconUrl(filename) : defaultImg;
}

function OrderPage() {
  useScrollMemory();

  const { kingdomName, phylumName, className, uid } = useParams();

  const location = useLocation();

  const currentUID = auth.currentUser?.uid;
  const dataUID = uid || currentUID;
  const orders = ordersByClass[className] || [];

  const adminModeActive =
    !!uid && new URLSearchParams(location.search).get("adminMode") === "true";

  const adminModeSuffix = adminModeActive ? "?adminMode=true" : "";

  const [speciesCounts, setSpeciesCounts] = useState({});
  const [loadingCounts, setLoadingCounts] = useState(true);

  const [browseMode, setBrowseMode] = useState("taxonomy");
  useEffect(() => {
    let cancelled = false;

    async function fetchSpeciesCounts() {
      setLoadingCounts(true);

      try {
        const snapshot = await getDocs(
          collection(db, "users", dataUID, "species"),
        );

        const counts = {};

        snapshot.forEach((doc) => {
          const data = doc.data();
          const genus = data?.genus?.toLowerCase();

          if (!genus) return;

          // 🔹 Find family
          const familyKey = Object.keys(generaByFamily).find((fam) =>
            generaByFamily[fam].map((g) => g.toLowerCase()).includes(genus),
          );

          if (!familyKey) return;

          // 🔹 Find order
          const orderKey = Object.keys(familiesByOrder).find((ord) =>
            familiesByOrder[ord]
              .map((f) => f.toLowerCase())
              .includes(familyKey.toLowerCase()),
          );

          if (!orderKey) return;

          const normalizedOrder = orderKey.toLowerCase();

          counts[normalizedOrder] = (counts[normalizedOrder] || 0) + 1;
        });

        if (!cancelled) setSpeciesCounts(counts);
      } catch (err) {
        console.error("Failed to load species counts:", err);
        if (!cancelled) setSpeciesCounts({});
      } finally {
        if (!cancelled) setLoadingCounts(false);
      }
    }

    fetchSpeciesCounts();

    return () => {
      cancelled = true;
    };
  }, [dataUID]);

  const visibleItems = orders.filter(
    (item) => Number(speciesCounts[item.toLowerCase()] || 0) > 0,
  );
  const totalSpecies = visibleItems.reduce(
    (sum, item) => sum + Number(speciesCounts[item.toLowerCase()] || 0),
    0,
  );
  const routePrefix = uid ? `/explore/${uid}` : "";

  return (
    <BioIndexExploreLevelLayout
      uid={uid}
      dataUID={dataUID}
      currentLevel="order"
      params={{ kingdomName, phylumName, className }}
      browseMode={browseMode}
      setBrowseMode={setBrowseMode}
      isOwnCollection={!uid || uid === currentUID}
      itemName="orders"
      itemCount={visibleItems.length}
      secondaryCount={totalSpecies}
      adminModeActive={adminModeActive}
    >
      {loadingCounts ? (
        <div className="bioindex-explore-empty" role="status">
          <span className="bioindex-explore-spinner" aria-hidden="true" />
          <h2>Loading orders</h2>
        </div>
      ) : visibleItems.length === 0 ? (
        <div className="bioindex-explore-empty">
          <h2>No orders to explore yet</h2>
          <p>There are no documented species in this group yet.</p>
        </div>
      ) : (
        <div className="bioindex-explore-kingdom-grid">
          {visibleItems.map((item) => {
            const key = item.toLowerCase();
            const count = Number(speciesCounts[key] || 0);
            const path = `/kingdom/${kingdomName}/phylum/${phylumName}/class/${className}/order/${key}`;
            const to = uid ? `${routePrefix}${path}${adminModeSuffix}` : path;
            return (
              <BioIndexTaxonCard
                key={item}
                name={item}
                count={count}
                image={getOrderImage(item)}
                to={to}
                level="order"
                italic={false}
              />
            );
          })}
        </div>
      )}
    </BioIndexExploreLevelLayout>
  );
}

export default OrderPage;
